export default "__VITE_ASSET__BznJCxOe__"